import { Injectable } from "@angular/core";
import { PaymentMethod } from "../models/PaymentMethod";

@Injectable()
export class PaymentMethodService {

    nameof(id: number) {
        switch(id) {
            case PaymentMethod.usdtErc20:
                return 'ERC-20 (USDT)';
            case PaymentMethod.usdtTrc20:
                return 'TRC-20 (USDT)';
            case PaymentMethod.googlePay:
                return 'Google Pay';
            case PaymentMethod.applePay:
                return 'Apple Pay';
            case PaymentMethod.monero:
                return 'Monero';
            case PaymentMethod.openBanking:
                return 'Open Banking';
            case PaymentMethod.creditCard:
                return 'Credit Card';
            case PaymentMethod.tron:
                return 'Tron';
            case PaymentMethod.ethereum:
                return 'Ethereum';
            case PaymentMethod.bitcoin:
                return 'Bitcoin';
            case PaymentMethod.payPal:
                return 'PayPal';
            case PaymentMethod.cardMember:
                return 'Card Member';
            case PaymentMethod.peerToPeer:
                return 'Peer-to-Peer';
            case PaymentMethod.unionPay:
                return 'Union Pay';
            case PaymentMethod.alternativePayment:
                return 'Alt. Payment';
            case PaymentMethod.demoPay:
                return 'Demo Pay';
            case PaymentMethod.usdcErc20:
                return 'ERC-20 (USDC)';
            default:
                return '';
        }
    }
}